import * as React from "react";
import { userInfoStore } from "Stores/UserInfoStore";

import { getUrlParams } from "utils/getUrlParams";
import { Loader } from "Components/General/Loader";
import { useLocation, useNavigate } from "react-router-dom";

export const DirectURLs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  React.useLayoutEffect(() => {
    const { csrf } = userInfoStore;
    const { pathname, search } = location;
    const { id } = getUrlParams(search) as { id: string };

    const mapCmd = {
      attachment: "di",
      internal: "dimic",
      external: "dimi",
      directmessagereq: "directmessagereq",
    };

    const cmd = mapCmd[pathname.split("/")[2]] || navigate("/login");

    const href =
      document.location.origin + "/" + window.GLOBAL.API_BASE + `MainServlet?cmd=${cmd}&id=${id}&csrf=${csrf}`;
    window.location.assign(href);
  }, []);

  return <Loader />;
};
